export default "__VITE_ASSET__Ce2$nMTv__"